export default __webpack_public_path__ + "static/media/DaviMarcos_02.bf32d6b5.jpg";